@if (
  (enableExpandLofiReportPanel$ | async) &&
  (layoutService.isDesktopView$ | async)
  ) {
  <div
    >
    @if (!hidden) {
      <div class="lofi-expand-button-container">
        <button
          class="mat-focus-indicator atlas-icon-button mat-flat-button mat-primary icon"
          mat-flat-button
          color="primary"
          aria-label="Street view"
          (click)="showLofiPanel()"
          >
          <mat-icon>bar_chart</mat-icon>
        </button>
      </div>
    }
    @if (hidden) {
      <div class="lofi-panel-container">
        <mat-icon class="lofi-image-close" (click)="hideLofiPanel()"
          >close</mat-icon
          >
          <div class="lofi-panel">
            <!-- remove the extra div when sm gets graphs-->
            @if (isSMFeatureSelected$ | async) {
              <div style="margin-top: 20px">
                <atlas-spatial-modeller-reports-panel>
          *ngIf="isSMFeatureSelected$ |
          async"</atlas-spatial-modeller-reports-panel
                  >
                </div>
              }
              @if (isLocatorFeatureSelected$ | async) {
                <atlas-locator-reports-panel
                  [pieGridView]="pieGridView"
                  [numberCardView]="numberCardView"
                  [graphHeight]="470"
                ></atlas-locator-reports-panel>
              }
            </div>
          </div>
        }
      </div>
    }
